import CompanyMetaField from "@/components/company-meta-field";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { mapCompanySizeToLabel } from "@/mappers/companies";
import { Regime } from "@/types/company";
import { Building } from "lucide-react";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

type CompanyDetailsProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    companyName: string;
    companySize: Regime;
    sector: string;
    subsector: string;
  }>;

export const CompanyDetails: FC<CompanyDetailsProps> = (props) => {
  return (
    <Card className={props.className}>
      <CardContent className="px-3 py-6">
        <div className="mb-6 flex items-center gap-2">
          <div className="flex aspect-square w-12 items-center justify-center rounded-full bg-[#615CB7] text-white">
            <Building size={28} />
          </div>

          <h2 className="grow text-2xl font-semibold text-[#293038]">
            {props.companyName}
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2 grid grid-cols-2 gap-4">
            <CompanyMetaField label="Razón social">
              {props.companyName}
            </CompanyMetaField>

            <CompanyMetaField label="Tamaño">
              <Badge variant={"gold"}>
                {mapCompanySizeToLabel(props.companySize)}
              </Badge>
            </CompanyMetaField>

            <CompanyMetaField label="Sector">{props.sector}</CompanyMetaField>

            <CompanyMetaField label="Subsector">
              {props.subsector}
            </CompanyMetaField>
          </div>

          {props.children}
        </div>
      </CardContent>
    </Card>
  );
};
